<template>
  <v-app :style="getBg">
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <span style="cursor:pointer" @click="reload" class="title">Pump Selection Software</span>
      </div>

      <v-spacer></v-spacer>
<span v-if="username" class="mr-8">Welcome {{ username }}</span> 
      <v-btn v-if="token" @click="logout" text>
        <span class="mr-2">Logout </span>
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>

    <v-container>
      <v-content>
        <v-tabs v-if="admin">
          <!-- <v-tab @click="$router.push('/')">Performanslar</v-tab> -->
          <v-tab @click="$router.push('/pumps').catch(err => {  })">Pumps</v-tab>
          <v-tab @click="$router.push('/motor').catch(err => {  })">Motors</v-tab>
          <v-tab @click="$router.push('/users').catch(err => {  })">Users</v-tab>
          
        </v-tabs>


        <!-- <v-col
          cols="12"
          sm="12"
          v-if=" $router.currentRoute.path == '/' || $router.currentRoute.path.startsWith('/pump')"
        >
          <div>
            <v-btn text @click="$router.push('/pump-performance-add')">Save Performance Data</v-btn>
            <v-btn text @click="$router.push('/pump-add')">Create Pump</v-btn>
          </div>
        </v-col>-->

        <!-- <v-col cols="12" sm="12" v-if=" $router.currentRoute.path.startsWith('/motor') ">
          <div>
            <v-btn text @click="$router.push('/motor-add')">Create Motor</v-btn>
            <v-btn text @click="$router.push('/motor-edit/test')">Edit Motor</v-btn>
          </div>
        </v-col>-->
      </v-content>

    </v-container>

    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
computed: {
    getBg () {
      // console.log(this)
      if (this.$route.path.length < 5)
        return "background-image:url('/maxibg.jpg')"
      // else
        // return "background-blend-mode: lighten;background-color: rgba(200,200,200,0.4);background-image:url('/maxibg.jpg')"
    
    }
  },
  components: {},

  data: () => ({
    currentLinkSelection: "",
    editMotorId: 100,
    admin: false,
    token: null,
    username: "",
  }),

  mounted: function() {
    if(localStorage.admin){
      this.admin = localStorage.admin
    }
    if(localStorage.username){
      this.username = localStorage.username
    }
    if(localStorage.token){
      this.token = localStorage.token
    }
  },
  watch: {
    admin(newValue){
      localStorage.admin = newValue
    },
    token(newValue){
      localStorage.token = newValue
    },
    username(newValue){
      localStorage.username = newValue
    },
    
  },
  methods: {
    reload : function() {
      document.location = "/"
      // document.location.reload()
    },

    logout: function() {
      localStorage.removeItem('token')
      localStorage.removeItem('admin')
      localStorage.removeItem('username')

      this.reload()
    }

  }
};
</script>
